import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ExtractEffects } from './extract.effects';
import { reducer } from './extract.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('extract', reducer),
    EffectsModule.forFeature([ExtractEffects]),
  ],
  providers: [ExtractEffects],
})
export class ExtractStoreModule {}
